export default __webpack_public_path__ + "sprite.ff6218e2abfc3e3f7542.svg";